class ServerError extends Error {
  status = 0;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export default ServerError;
